import type { DurationWarning } from './bombeoDuration'
import type { StayWindow } from './sostratBombeo'
import { type EventMarker, eventMarkers } from './summarise'
import type { EventRow } from './types'

export type ScaleWarning =
  | { kind: 'DURATION'; marker: EventMarker; warning: DurationWarning }
  | { kind: 'IMPLAUSIBLE_QUANTITY'; marker: EventMarker; goods: string | null; quantity: number | null; unit: string | null }
  | { kind: 'OUTSIDE_STAY'; marker: EventMarker; stay: StayWindow }
  | { kind: 'MISSING_PRODUCT' | 'MISSING_TONNES'; marker: EventMarker }

export const scaleWarnings = (events: readonly EventRow[], now: number): ScaleWarning[] => {
  const stays = new Map(events.map(event => [event.id, event]))
  return eventMarkers(events, now).flatMap((marker): ScaleWarning[] => {
    if (marker.type === 'PLACE')
      return (stays.get(marker.id)?.operations ?? [])
        .filter(operation => operation.quantityBasis === 'IMPLAUSIBLE')
        .map(({ goods, quantity, unit }) => ({ kind: 'IMPLAUSIBLE_QUANTITY', marker, goods, quantity, unit }))
    if (marker.type !== 'BOMBEO') return []
    const warnings: ScaleWarning[] = marker.durationWarning === null ? [] : [{ kind: 'DURATION', marker, warning: marker.durationWarning }]
    if (marker.outsideStay !== null) warnings.push({ kind: 'OUTSIDE_STAY', marker, stay: marker.outsideStay })
    if (!marker.fromSostrat && (marker.product === null || marker.product.trim() === '')) warnings.push({ kind: 'MISSING_PRODUCT', marker })
    if (!marker.fromSostrat && marker.quantityT === null) warnings.push({ kind: 'MISSING_TONNES', marker })
    return warnings
  })
}
